import { type StatesList } from '@tdwb/webbroker/core';
import { PortfolioContactsComponent } from './portfolio-contacts.component';

export class PortfolioContactsRoutes {
  static states: StatesList = [
    {
      name: 'modal.portfolio-contacts',
      url: '/pic/contacts',
      data: {
        modalOptions: {
          component: PortfolioContactsComponent,
          size: 'small'
        }
      }
    }
  ];
}
